import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { FormGroup, FormControl, AbstractControl, NgForm, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { APIPaymentService } from '../../_services/payment-dues/payment-dues.service';
import { APITemplateService } from '../../_services/template/API-template';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { Constants } from '../../../../_utils/Constants';
import { formatDate } from '@angular/common';
import { APIEntityService } from '../../_services/entity/API-entity';
import { APIHeaderService } from '../../_services/header/API-header';
import { saveAs as importedSaveAs } from "file-saver";
import { GstRegistrationService } from '../../_services/gst-registration/gst-registration.service';

//below code for Current Data
const now = new Date();
const currentdate = formatDate(now, 'yyyy-MM-dd', 'en-US', '+0530');

@Component({
	selector: 'app-gst-registration-details',
	templateUrl: './gst-registration-details.component.html',
	styleUrls: ['./gst-registration-details.component.css']
})
export class GstRegistrationDetailsComponent implements OnInit {
	enableMdifyBtn = false
	enableSubmitbTN = false;
	URN: "";
	entity_id: any;
	entity_legalname: any;
	gst_number: any;
	address: any;
	location: any;
	state: any;
	pincode: any;
	email_id: any;
	entity_comments: any;
	uploader: any;
	RegistrationDetailsForm: FormGroup;
	isValid: boolean = false;
	templateIds: Number[] = [];
	photoName: any;
	fileExtension: any;
	fileExtensionError: boolean = false;
	fileExtensionMessage: any;
	photoContent: any;
	fileSizeError1: boolean = false;
	fileSizeError2: boolean = false;
	disableForm: boolean = false;
	myfiles = [];
	styledetail = "background-color: #ececec; padding-bottom: 10px;"
	constructor(private fb: FormBuilder,
		private ps: APIPaymentService,
		private $modal: $ModalManagerService,
		private db: $DBManagerService,
		private _route: ActivatedRoute,
		private es: APIEntityService,
		private hs: APIHeaderService,
		private gs: GstRegistrationService,

		private router: Router) {


	}
	validateGSTNum(): ValidatorFn {

		return (control: AbstractControl): ValidationErrors | null => {
			let val = control.value;
			let stat = this.gs.getstates().filter((f) => {
				return f.stateid == val.substr(0, 2);
			});
			
			let ret = (val.length != 15 || !stat || stat.length == 0) ? { validateGSTNum: true } : null;
			this.RegistrationDetailsForm.get("state").markAsTouched()
			return ret
		};
	}
	// validateGSTNum() {
	// 	debugger
	// 	let val = control.value;

	// 	let stat = this.gs.getstates().filter((f) => {
	// 		return f.stateid == val.substr(0, 2);
	// 	});
	// 	if (val.length != 15 || !stat || stat.length == 0)
	// 		return {
	// 			validateGSTNum: {
	// 				valid: false
	// 			}
	// 		};
	// 	else return null
	// }
	// validateGSTNum(c: FormControl) {
	// 	debugger
	// 	let val = c.value;

	// 	let stat = this.gs.getstates().filter((f) => {
	// 		return f.stateid == val.substr(0, 2);
	// 	});
	// 	if (val.length != 15 || !stat || stat.length == 0)
	// 		return {
	// 			validateGSTNum: {
	// 				valid: false
	// 			}
	// 		};
	// 	else return null

	// }
	get f() { return this.RegistrationDetailsForm.controls; }

	ngOnInit() {
		this.RegistrationDetailsForm = this.fb.group({
			entity_id:new FormControl({ disabled: true, value: '' }, [Validators.required]),
			entity_legalname:new FormControl({ disabled: true, value: '' }, [Validators.required, Validators.maxLength(100), Validators.minLength(3)]),
			// gst_number: ['',{disabled: true}, [Validators.maxLength(15)]),
			gst_number: new FormControl({ disabled: true, value: '' }, [Validators.required, this.validateGSTNum()]),
			address:new FormControl({ disabled: true, value: '' }, [Validators.required, Validators.maxLength(250), Validators.minLength(5)]),
			location:new FormControl({ disabled: true, value: '' }, [Validators.required, Validators.maxLength(100), Validators.minLength(3)]),
			state:new FormControl({ disabled: true, value: '' }, [Validators.required]),
			//pincode: ['',{disabled: true}, [Validators.required, Validators.maxLength(6), Validators.minLength(6)]),
			pincode:new FormControl({ disabled: true, value: '' }, [Validators.required, Validators.pattern("^[1-9][0-9]{5}$")]),
			email_id:new FormControl({ disabled: true, value: '' }, [Validators.required]),
			action_status:new FormControl({ disabled: true, value: '' }, [Validators.required]),
			gst_CertificateName:new FormControl({ disabled: true, value: '' }, [Validators.required]),
			approver_comments:new FormControl({ disabled: true, value: '' }),
			entity_comments: new FormControl({ disabled: true, value: '' }),
			action_date: new FormControl({ disabled: true, value: '' }),
			uploader:new FormControl({ disabled: true, value: '' }, [Validators.required])
		});
		this.enableMdifyBtn = false;
		this.enableSubmitbTN = false;
		this.URN = this.db.get(Constants.SESSSION_STORAGE, Constants.URNFORGST);
		this.Fetchrecord();

	}//end of oninit

	fileEvent(event): any {

		var file = event.target.files[0];
		this.photoName = file.name;
		this.myfiles = event.target.files
		var allowedExtensions =
			["jpg", "pdf", "jpeg", "png", "jfif", "bmp", "svg"];
		this.fileExtension = this.photoName.split('.').pop();

		if (this.isInArray(allowedExtensions, this.fileExtension)) {
			this.fileExtensionError = false;
			this.fileExtensionMessage = ""
			alert("Invalid File 1 formate");
		} else {
			this.fileExtensionMessage = "Only photos allowed!!"
			alert("Invalid File 2 formate");
			this.fileExtensionError = true;
		}

		if (file) {
			var reader = new FileReader();
			reader.onloadend = (e: any) => {
				var contents = e.target.result;
				this.photoContent = contents;
			}
			reader.readAsDataURL(file);
		} else {
			alert("Failed to load file");
		}
	}
	/*- checks if word exists in array -*/
	isInArray(array, word) {
		return array.indexOf(word.toLowerCase()) > -1;
	}
	onChangeFileUpload(event) {

		this.myfiles = event.target.files;
		var file = event.target.files[0];
		this.photoName = file.name;
		console.log("the size is ", file.size)
		if (file.size > 4000000) {
			console.log("The size is more ")
			this.fileSizeError1 = true;
		}
		else {
			this.fileSizeError1 = false;
		}
		if (file.size <= 0) {
			console.log("The size is less ")
			this.fileSizeError2 = true;
		}
		else {
			this.fileSizeError2 = false;
		}
		var allowedExtensions =
			["jpg", "pdf", "jpeg", "png", "jfif", "bmp", "svg"];
		this.fileExtension = this.photoName.split('.').pop();
		console.log("this.photoName   ----------- ", this.photoName)

		if (this.isInArray(allowedExtensions, this.fileExtension)) {
			this.fileExtensionError = false;
			this.fileExtensionMessage = ""
		} else {
			this.fileExtensionMessage = "Only photos allowed!!"
			this.fileExtensionError = true;
		}

		if (file) {
			var reader = new FileReader();
			reader.onloadend = (e: any) => {
				var contents = e.target.result;
				this.photoContent = contents;
			}
			reader.readAsDataURL(file);
		} else {
			alert("Failed to load file");
		}
		console.log("this is file extension error", this.fileExtensionError);
	}
	onSubmit() {

		if (this.RegistrationDetailsForm.invalid || this.fileExtensionError || this.fileSizeError1 || this.fileSizeError2) {
			this.disableForm = true;
			let invalid = [];
			let controls = this.RegistrationDetailsForm.controls;
			for (const name in controls) {
				if (controls[name].invalid) {
					invalid.push(name);
				}
			}
			return;
		}
		else {
			console.log("-------------------On Remove came here into onSubmit----------------")
		//	if (confirm("Are you sure you want to continue ! ")) {
				this.modifygstreg();
		//	}
		}
	}

	modifygstreg() {

		let EntityID = this.RegistrationDetailsForm.get("entity_id").value;
		let EntityLegalName = this.RegistrationDetailsForm.get("entity_legalname").value;
		let GSTNumber = this.RegistrationDetailsForm.get("gst_number").value;
		let Address = this.RegistrationDetailsForm.get("address").value;
		let Location = this.RegistrationDetailsForm.get("location").value;
		let State = this.RegistrationDetailsForm.get("state").value;
		let Pincode = this.RegistrationDetailsForm.get("pincode").value;
		let EmailID = this.RegistrationDetailsForm.get("email_id").value;
		let EntityComments = this.RegistrationDetailsForm.get("entity_comments").value;
		const GSTRegForm: FormData = new FormData();
		/*	let gstRegistrationdata = {
				'Entity_ID': EntityID,
				'CustLegalName': EntityLegalName,
				'Entity_GST_Id': GSTNumber,
				'Entity_Addr': Address,
				'Entity_City': Location,
				'Entity_State': State,
				'Entity_Pincode': Pincode,
				'Entity_EmailID': EmailID,
				'EntityComments': EntityComments,
				'StateGSTSeqNum': 12,
				'GSTfile': 123
			} */
		GSTRegForm.append('URN', this.URN);
		GSTRegForm.append('Entity_ID', EntityID);
		GSTRegForm.append('CustLegalName', EntityLegalName);
		GSTRegForm.append('Entity_GST_Id', GSTNumber);
		GSTRegForm.append('Entity_Addr', Address);
		GSTRegForm.append('Entity_City', Location);
		GSTRegForm.append('Entity_State', State.split("-")[1]);
		GSTRegForm.append('Entity_Pincode', Pincode);
		GSTRegForm.append('Entity_EmailID', EmailID);
		GSTRegForm.append('EntityComments', EntityComments);
		GSTRegForm.append('StateGSTSeqNum', State.split("-")[0]);
		const file1: any = document.getElementById('GSTfile');
		GSTRegForm.append('GSTfile', file1.files[0]);



		this.gs.ModifygstRegistration(GSTRegForm)
			.subscribe(r => {
				console.log(r)
				if (r.status == 'failed') {
					this.$modal.errorModal({
						title: 'Modify GST Registration',
						msg: r.message
					})

				}
				else if (r.status == 'error') {
					this.$modal.errorModal({
						title: 'Modify GST Registration',
						msg: 'Error in GST Registration'
					})
				}

				else {

					this.$modal.successModal({
						title: 'Modify GST Registration',
						msg: 'Your Request No(URN) ' + this.URN + ' is submitted for approval. You will receive an email on status within 24working hours. You can or visit Search GST Registration'
					})

				}
			})
	}


	changeGST(e) {
		console.log("event value", e.target.value)
		if (e.target.value.length == 15) {
			let stat = this.gs.getstates().filter((f) => {
				return f.stateid == e.target.value.substr(0, 2);
			});
			if (stat && stat.length > 0)
				this.RegistrationDetailsForm.controls['state'].setValue(stat[0].stateid + "-" + stat[0].statename)
			else
				this.RegistrationDetailsForm.controls['state'].setValue("")
		}
		else {
			this.RegistrationDetailsForm.controls['state'].setValue("")
		}

	}





	Fetchrecord() {


		this.gs.GetgstRegistrationDetails(this.URN)
			.subscribe(r => {
				console.log(r)
				if (r && r.length > 0) {
					this.RegistrationDetailsForm.controls['gst_number'].setValue(r[0].Entity_GST_Id);
					//this.RegistrationDetailsForm.controls['entityid'].enable();  
					this.RegistrationDetailsForm.controls['entity_id'].setValue(r[0].Entity_ID);
					this.RegistrationDetailsForm.controls['entity_legalname'].setValue(r[0].CustLegalName);
					this.RegistrationDetailsForm.controls['address'].setValue(r[0].Entity_Addr);
					this.RegistrationDetailsForm.controls['location'].setValue(r[0].Entity_City);
					this.RegistrationDetailsForm.controls['state'].setValue(r[0].Entity_GST_Id.substr(0, 2) + "-" + r[0].Entity_State);
					this.RegistrationDetailsForm.controls['pincode'].setValue(r[0].Entity_Pincode);
					this.RegistrationDetailsForm.controls['email_id'].setValue(r[0].Entity_EmailID);
					this.RegistrationDetailsForm.controls['action_status'].setValue(r[0].ApproverAction);
					this.RegistrationDetailsForm.controls['approver_comments'].setValue(r[0].ApproverComments);
					this.RegistrationDetailsForm.controls['action_date'].setValue(r[0].ApproverActionDt);
					this.RegistrationDetailsForm.controls['entity_comments'].setValue(r[0].EntityComments);
					this.RegistrationDetailsForm.controls['gst_CertificateName'].setValue(r[0].GSTDocName);

					this.myfiles = [r[0].GSTDocName];
					this.photoName = r[0].GSTDocName;

					this.enableMdifyBtn = r[0].ApproverAction == "Pending";
					this.disableControles()

				}

			});
	}
	enableControles() {
		this.RegistrationDetailsForm.controls['gst_number'].enable();
		this.RegistrationDetailsForm.controls['address'].enable();
		this.RegistrationDetailsForm.controls['location'].enable();
		this.RegistrationDetailsForm.controls['pincode'].enable();
		this.RegistrationDetailsForm.controls['state'].enable();
		this.RegistrationDetailsForm.controls['entity_comments'].enable();
		this.RegistrationDetailsForm.controls['gst_CertificateName'].enable();
		this.RegistrationDetailsForm.controls['uploader'].enable();
		this.RegistrationDetailsForm.updateValueAndValidity();

		//this.resetKYC()
	}
	disableControles() {
		this.RegistrationDetailsForm.controls['gst_number'].disable();
		this.RegistrationDetailsForm.controls['address'].disable();
		this.RegistrationDetailsForm.controls['location'].disable();
		this.RegistrationDetailsForm.controls['pincode'].disable();
		this.RegistrationDetailsForm.controls['state'].disable();
		this.RegistrationDetailsForm.controls['entity_comments'].disable();
		this.RegistrationDetailsForm.controls['gst_CertificateName'].disable();
		this.RegistrationDetailsForm.controls['uploader'].disable();
		this.RegistrationDetailsForm.updateValueAndValidity();
	}
	modifyClick() {
		let action_status = this.RegistrationDetailsForm.controls['action_status'].value
		console.log("action_status", action_status)
		if (action_status == "Pending") {
			this.enableMdifyBtn = false;
			this.enableSubmitbTN = true;
			this.enableControles()
		}
		else {
			this.enableMdifyBtn = false;
			this.enableSubmitbTN = false;
			this.disableControles()
		}
	}
	resetKYC() {

		this.fileExtensionError = false;
		this.fileSizeError1 = false;
		this.fileSizeError2 = false;

		console.log("resetKYC -1 :", this.RegistrationDetailsForm.controls['uploader'].value);
		this.RegistrationDetailsForm.controls['uploader'].reset();
		console.log("resetKYC -2 :", this.RegistrationDetailsForm.controls['uploader'].value);
		this.myfiles = [];
		this.photoName = "";
	}
	downloadgstcert() {
		this.gs.downloadGSTCert(this.URN)
			.subscribe(r => {
				console.log(r)
				//if (r && r.length > 0) {
				importedSaveAs(r, this.RegistrationDetailsForm.controls['gst_CertificateName'].value)

				//}

			});
	}
	reset() {
		if (this.enableSubmitbTN) {
			this.enableMdifyBtn = false;
			this.enableSubmitbTN = false;
			this.Fetchrecord()

		}
		else {
			this.router.navigate(['gstregistration-search'])
		}

	}



}